import { ChangeDetectorRef, Component, Renderer2 } from '@angular/core';
import { ApplicationStateService } from '../../../../services/application.state.service';
import { TrackingService } from '../../../../services/tracking.service';
import { ScenarioImageService } from '../../../../services/scenario-image/scenario-image.service';
import { VisualizeEngine } from '@door-vision/visualisation-engine';
import { AbstractRefinePanelComponent } from '../../../../panels/abstract.refine-panel.component';
import {DoorService} from "../../../../services/door/door.service";
import {CustomerService} from "../../../../services/customer/customer.service";

@Component({
  selector: 'app-refine-panel',
  templateUrl: './refine-panel.component.html',
})
export class RefinePanelComponent extends AbstractRefinePanelComponent {
  constructor(
    renderer: Renderer2,
    cdRef: ChangeDetectorRef,
    scenarioImageService: ScenarioImageService,
    doorService: DoorService,
    applicationStateService: ApplicationStateService,
    visualizeEngine: VisualizeEngine,
    trackingService: TrackingService,
    customerService: CustomerService) {
    super(renderer, cdRef, scenarioImageService, doorService, applicationStateService, visualizeEngine, trackingService, customerService);
  }
}


